import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { Accordion,AccordionSummary,Typography,AccordionDetails,Container, Button, Paper, Table, TableHead, TableBody, TableRow, TableCell,useMediaQuery, TableContainer,TextField,Stack } from '@mui/material';
import { BASE_URL } from "../../App";
import CustomTextField from "../Reusable/Numerictext";
import { SelectSearch } from '../Reusable/SelectBox';
import { Row, Col, Card } from 'antd';
import dayjs from 'dayjs';
import { Modal, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import Autocomplete from '@mui/material/Autocomplete';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import ReceiptLongTwoToneIcon from '@mui/icons-material/ReceiptLongTwoTone';
import UndoTwoToneIcon from '@mui/icons-material/UndoTwoTone';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { useLocation } from 'react-router-dom';

const DeliveryChallan = () => {
    const [serviceClaims, setServiceClaims] = useState([]);
    const [open1, setOpen1] = React.useState(false);
	const [loginId, setLoginId] = useState(null);
    // const [status, setstatus] = useState([]);
    
   
    const [callheader, setcallheader] = useState([]);
    const [dealerdesc, setdealerdesc] = useState([]);
    const [itemdesc, setitemdes] = useState([]);

    const [selectedStatus, setSelectedStatus] = useState(null);
     const [selectedstatus, setSelectedstatus] = useState("Close");
   
   
    const [selectedRowData, setSelectedRowData] = useState(null);
	const [images, setImages] = useState({ image1: '', image2: '', image3: '', image4: '' });
	 
    const [openCard, setOpenCard] = useState(false);
    const [showTable, setShowTable] = useState(true);
    const [header, setHeader] = useState([]);
    const [callHeader, setCallHeader] = useState([]);
    const [dealerDesc, setDealerDesc] = useState([]);
    const [itemDesc, setItemDesc] = useState([]);
    const [loading, setloading] = React.useState(false);
    // const login_id = localStorage.getItem("LOGIN_ID");
	const [callpre, setCallpre] = useState([]);
    const [open, setOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const deliverydate =header.CREATEDON?dayjs(header.CREATEDON):dayjs();
    const minDate = deliverydate.subtract(15, 'days');
    const maxDate = dayjs();
    const handleOpen = (image) => {
        setSelectedImage(image);
        setOpen(true);
    };
    
    const handleClose = () => {
        setOpen(false);
        setSelectedImage(null);
    };

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '80%',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
    };
    const closeButtonStyle = {
        position: 'absolute',
        top: 8,
        right: 8,

    };

    const handleUnitChange = (event, newValue) => {
        setSelectedstatus(newValue);
    }
	
	
	
	  const location = useLocation();
	  const queryParams = new URLSearchParams(location.search);

      const isMobile = useMediaQuery('(max-width:768px)');

      const [expanded, setExpanded] = useState(false);

        const handleChange = (panel) => (event, isExpanded) => {
            setExpanded(isExpanded ? panel : false);
        };

		useEffect(() => {
			  
			  if (!queryParams.get('LOGIN_ID')) {
				const login_id = localStorage.getItem("LOGIN_ID");
				fetchData(login_id);
				setLoginId(login_id);
			  } else {
			   const login_id1 = queryParams.get('LOGIN_ID');
			   
				axios.post(BASE_URL +"/getloginidEncode",{login_id : login_id1})
				  .then((response) => {
					const login_id = response.data.login_id;
					fetchData(login_id);
					setLoginId(login_id);
				  })
				  .catch((error) => {
					Swal.fire('Error','LOGIN_ID NOT DECRIPTED', 'error');
				  });
			  }
		  }, []);
	  
  
    // useEffect(() => {
        const fetchData = async (login_id) => {
            try {
                const response = await axios.post(BASE_URL + '/getpendingclaimdetails', { login_id: login_id });
                if (response.status === 200) {
                    setServiceClaims(response.data.getpendingclaimdetails);
                } else {
                    // Swal.fire({
                    //     icon: "warning",
                    //     text: 'Unexpected response status. Please try again.'
                    // });
                }
            } catch (error) {
                if (error.response) {
                    Swal.fire({
                        icon: "warning",
                        text: `Error: ${error.response.data.message}`
                    });
                } else if (error.request) {
                    console.error('No response received');
                } else {
                    console.error('Error setting up the request:', error.message);
                }
            }
        };
        // fetchData();
    // }, []);

    const handleOpen1 = () => setOpen1(true);


    const handleOpenCard = (rowData) => {
        setSelectedRowData(rowData); // Set the selected row data
        setOpenCard(true);
        setShowTable(false); // Hide the table when the card is opened
        setloading(true);
        // Fetch the headers first
        axios.post(BASE_URL + '/getclaimheader', {
            serialno: rowData.SERIAL_NO,
            Docno: rowData.DOC_NO,
            login_id: loginId,
            Status: 'SS'
        })
        .then(response => {
            setloading(true);
            const responseData = response.data;
            const headerdetails = responseData.getclaimheader || [];
            setHeader(headerdetails);
setImages({
                    image1: response.data.image1,
                    image2: response.data.image2,
                    image3: response.data.image3,
                    image4: response.data.image4
                }); 
            setloading(true);
            return axios.post(BASE_URL + '/loadItemDescription', {
                
                serial_no: rowData.SERIAL_NO,
                lblMatDescription: headerdetails.length > 0 ? headerdetails[0].MAT_CODE : '',
                login_id:loginId 
            });
        })
        .then(response => {
            setloading(true);
            const responseData = response.data;
            const itemdes1 = responseData.loadItemDescription || [];
            setItemDesc(itemdes1);
            setloading(false);
        })
        .catch(error => {
            setloading(false);
            console.error('API Error:', error);
        });
       // setloading(true);
	   axios.post(BASE_URL + '/getperviousclaim', {
            
            serialno: rowData.SERIAL_NO,
            Docno: rowData.DOC_NO,
            login_id: loginId,
            Status: 'SS'
        })
        .then(response => {
            setloading(true);
            const responseData = response.data;
            const headerdetails2 = responseData.getperviousclaim || [];
            setCallpre(headerdetails2);
            console.log(callpre);
            setloading(false);
        })
        axios.post(BASE_URL + '/loadcallClaimheader', {
            
            serialno: rowData.SERIAL_NO,
            Docno: rowData.DOC_NO,
            login_id: loginId,
            Status: 'SS'
        })
        .then(response => {
            setloading(true);
            const responseData = response.data;
            const headerdetails1 = responseData.loadcallClaimheader || [];
            setCallHeader(headerdetails1);
            setloading(false);
        })
        
        .catch(error => {
            setloading(false);
            console.error('API Error:', error);
        });

        axios.post(BASE_URL + '/getdealerdesc', {
            serialno: rowData.SERIAL_NO,
            Docno: rowData.DOC_NO,
            login_id: loginId
        })
        .then(response => {
            setloading(true);
            const responseData = response.data;
            const dealerdes = responseData.getdealerdesc || [];
            setDealerDesc(dealerdes);
            setloading(false);
        })
        .catch(error => {
            setloading(false);
            console.error('API Error:', error);
        });
        ///setloading(false);
    };

    const handleCloseCard = () => {
        setOpenCard(false);
        setShowTable(true); // Show the table when the card is closed
    };

    const options = [
    
    { label: 'Closed', value: 'closed' },
  
];
const [selectedDate, setSelectedDate] = useState(null);

const handleDateChange = (date) => {
    setSelectedDate(date);
};

const handlesubmit = () => {


    const data = {

       
        login_id: loginId,
      
        doc_no: selectedRowData.DOC_NO,
        serial_no: selectedRowData.SERIAL_NO,
       
        delivery_date: selectedDate,


    };

    axios.post(BASE_URL + '/readyToClaim', data)
        .then(response => {
            if (response.status === 200) {
               
                Swal.fire({
                    icon: "success",
                    text: response.data.text || 'Data saved successfully!',
                });
                window.location.reload();

            } else {
                Swal.fire({
                    icon: "warning",
                    text: 'Unexpected response status. Please try again.'
                });
            }
        })
        .catch(error => {
            if (error.response) {
                Swal.fire({
                    icon: "warning",
                    text: `Error: ${error.response.data.text}`
                });
            } else if (error.request) {
                console.error('No response received');
            } else {
                console.error('Error setting up the request:', error.message);
            }
        });
};

const defaultValue = options[0];



    return (
        <Container>
            <br />
            {showTable && ( 
                <div>
            <center><h3 style={{ padding: '5px', background: '#e3fafe', color: 'black' }} >Pending Delivery Challan Details</h3></center>
            <hr />
{ 
    isMobile ? (
            <div>
                {serviceClaims &&
                    serviceClaims.map((row, index) => (
                    <Accordion
                        key={index}
                        expanded={expanded === index}
                        onChange={handleChange(index)}
                        sx={{
                        mb: 1,
                        borderRadius: "12px",
                        boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                        backgroundColor: "#e3fafe",
                        }}
                    >
                        <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        sx={{
                            background: "#61d1e5",
                            borderRadius: "12px",
                            padding: "8px 16px",
                        }}
                        >
                        <Typography sx={{ flex: 1, fontWeight: "bold" }}>
                            {index + 1}. Token: {row.TOKEN_NUMBER} | Serial: {row.SERIAL_NO}
                        </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                        <Typography>📄 Doc Number: {row.DOC_NO}</Typography>
                        <Button
                            variant="contained"
                            onClick={() => handleOpenCard(row)}
                            color="primary"
                            sx={{ mt: 1 }}
                        >
                            Delivery Challan
                        </Button>
                        </AccordionDetails>
                    </Accordion>
                    ))}
                </div>

    ) : (
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>S.No</TableCell>
                            <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>TOKEN NUMBER</TableCell>
                            <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>DOC NUMBER</TableCell>
                            <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>SERIAL NO</TableCell>
                            <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {serviceClaims && serviceClaims.map((row, index) => (
                            <TableRow key={index}>
                                <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>{index + 1}</TableCell>
                                <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>{row.TOKEN_NUMBER}</TableCell>
                                <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>{row.DOC_NO}</TableCell>
                                <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>{row.SERIAL_NO}</TableCell>
                                <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>
                                    <Button variant="contained"   onClick={() => handleOpenCard(row)} color="primary" >Delivery Challan</Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
    )
}

            </div>
)}
            {openCard && selectedRowData &&  (
                <div>
                    <br/>

<Card style={{
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                borderRadius: '10px',
            }}>

<div className='row'>
                        <div className='col-md-2'>
                        <Button size="small" fullWidth variant="contained" onClick={() => handleCloseCard()} endIcon={<UndoTwoToneIcon />}  ><b>Back</b></Button>
                        </div>
                        <div className='col-md-2'>
   
    
</div>
<div className='col-md-2'>
    <label htmlFor="mobileNumber">Previous Claim On</label>
    
</div>
<div className='col-md-2'>
    <label htmlFor="prevoiusclaimnon" value={callpre.length > 0 ? callpre[0].CREATEDON : ''}><span>{callpre.length > 0 ? callpre[0].CREATEDON : ''}</span></label>
    
</div>
<div className='col-md-2'>
    <label htmlFor="mobileNumber">Previous Claim By</label>
    
</div>
<div className='col-md-2'>
    <label htmlFor="prevoiusclaimnon"  value={callpre.length > 0 ? callpre[0].CREATEDBY : ''}><span>{callpre.length > 0 ? callpre[0].CREATEDBY : ''}</span></label>
    
</div>

                        
                    </div>

                </Card>
            <br />

            <Card style={{
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                borderRadius: '10px',
            }}>

                <center><h3 style={{ padding: '5px', background: '#e3fafe', color: 'black' }} > Delivery Challan </h3></center>
                <div className="mt-5" style={{ justifyContent: 'center' }}>
                    <div className='row'>
                        <div className='col-md-4'>
                            <CustomTextField
                                label="Code"
                                fullWidth
                                margin="normal"
                                value={header.length > 0 ? header[0].DEALER_CODE : ''}
                            />
                        </div>
                        <div className='col-md-4'>
                            <CustomTextField
                                label="Name"
                                fullWidth
                                margin="normal"
                                value={header.length > 0 ? header[0].ASC_NAME : ''}
                            />
                        </div>
                        <div className='col-md-4'>
                            <CustomTextField
                                label="Product"
                                fullWidth
                                margin="normal"
                                value={itemDesc.length > 0 ? itemDesc[0].itemdescription : ''}
                            />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-4'>
                            <CustomTextField
                                label="Product Code"
                                fullWidth
                                margin="normal"
                                value={header.length > 0 ? header[0].MAT_CODE : ''}
                            />
                        </div>
                        <div className='col-md-4'>
                            <CustomTextField
                                label="Serial Number"
                                fullWidth
                                margin="normal"
                                value={selectedRowData.SERIAL_NO}
                            />
                        </div>
                        <div className='col-md-4'>
                            <CustomTextField
                                label="Service Type"
                                fullWidth
                                margin="normal"
                                value={header.length > 0 ? header[0].SERVICE_TYPE : ''}
                            />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-4'>
                            <CustomTextField
                                label="SCR Number"
                                fullWidth
                                margin="normal"
                                value={header.length > 0 ? header[0].SERVICECALL_NO : ''}
                            />
                        </div>
                        <div className='col-md-4'>
                            <CustomTextField
                                label="Mobile Number"
                                fullWidth
                                margin="normal"
                                value={callHeader.length > 0 ? callHeader[0].CUSTOMER_PHONE_NUMBER : ''}
                            />
                        </div>
                        <div className='col-md-4'>
                            <CustomTextField
                                label="Received From Name"
                                fullWidth
                                margin="normal"
                                value={callHeader.length > 0 ? callHeader[0].CUSTOMER_NAME : ''}
                            />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-4'>
                            <textarea
                                className='form-control'
                                placeholder="Address"
                                 value={callHeader.length > 0 ? callHeader[0].CUSTOMER_ADDRESS : ''}
                                rows={3}
                            />
                        </div>
                    </div>
                </div>
            </Card>
<br/>
            <Card style={{
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                borderRadius: '10px',
            }}>

                <center><h3 style={{ padding: '5px', background: '#e3fafe', color: 'black' }} > Status </h3></center>

                <div className='row'>
                        <div className='col-md-4'>
                       
                                <label></label>
                               
                                <Autocomplete
            options={options}
            getOptionLabel={(option) => option.label}
            defaultValue={defaultValue} // Set the default value here
            renderInput={(params) => (
                <TextField {...params} label="Choose a status" variant="outlined" />
            )}
            style={{ width: 300 }}
        />
                        </div>
                        <div className='col-md-4'>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoContainer
                                components={[
                                    'DatePicker',
                                    'MobileDatePicker',
                                    'DesktopDatePicker',
                                    'StaticDatePicker',
                                ]}
                            >
                                <Stack spacing={2} sx={{}}>
                                <label></label>
                                    {/* <label className="form-label" style={{ float: "left", fontWeight: "bold" }} >To Date</label> */}
                                    <div>
                                        <DemoItem>
                                            <MobileDatePicker onChange={handleDateChange}
                                            minDate={minDate}
                                             maxDate={maxDate}
                                            value={selectedDate} 
                                            defaultValue={dayjs('')} label="Delivery Date" />
                                        </DemoItem>
                                    </div>
                                </Stack>
                            </DemoContainer>
                        </LocalizationProvider>
                        </div>
                        <div className='col-md-4'>
                        <label></label>
                       
                            <CustomTextField
                                label="ASC Warrenty Date"
                                fullWidth
                                margin="normal"
                                value={90}
                            />
                        </div>
                    </div>
					   <br/>
                        <div className='row' >
                            
                        <div>
            <label htmlFor="mobileNumber">Service Claim Images</label>
            <div>
                <>
                    {images.image1 ? (
         

                        <img className="mb-2" src={`data:image/png;base64,${images.image1}`} alt="Image 1" style={{ height: '100px', width: '100px', cursor: 'pointer' }} onClick={() => handleOpen(images.image1)} />
                    ) : (
                        <center><b className="text-danger">Image 1 Not Found!!</b></center>
                    )}&emsp;&emsp;

                    {images.image2 ? (
                        <img className="mb-2" src={`data:image/png;base64,${images.image2}`} alt="Image 2" style={{ height: '100px', width: '100px', cursor: 'pointer' }} onClick={() => handleOpen(images.image2)} />
                    ) : (
                        <center><b className="text-danger">Image 2 Not Found!!</b></center>
                    )}&emsp;&emsp;

                    {images.image3 ? (
                        <img className="mb-2" src={`data:image/png;base64,${images.image3}`} alt="Image 3" style={{ height: '100px', width: '100px', cursor: 'pointer' }} onClick={() => handleOpen(images.image3)} />
                    ) : (
                        <center><b className="text-danger">Image 3 Not Found!!</b></center>
                    )}&emsp;&emsp;

                    {images.image4 ? (
                        <img className="mb-2" src={`data:image/png;base64,${images.image4}`} alt="Image 4" style={{ height: '100px', width: '100px', cursor: 'pointer' }} onClick={() => handleOpen(images.image4)} />
                    ) : (
                        <center><b className="text-danger"></b></center>
                    )}
                </>
            </div>
             <Modal open={open} onClose={handleClose}>
                <Box sx={style}>
                    <Button sx={closeButtonStyle} onClick={handleClose} color="error" variant="contained" endIcon={<CloseIcon />}>
                 
                    </Button>
                    <img src={`data:image/png;base64,${selectedImage}`} alt="Selected" style={{ width: '85%' }} />
                </Box>
            </Modal>
        </div>
                
                        </div>
                    <br/>
                    <div className='row'>
                    <Button size="small" fullWidth variant="contained"  onClick={handlesubmit}  ><b>Proceed For Bill Claiming</b></Button>
                </div>
            </Card>
            </div>

)}


        </Container>
    );
};

export default DeliveryChallan;
